import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useToast } from "@/hooks/use-toast.js";
import PropTypes from "prop-types";
import React from "react";
import { useGetProjects, useUpdateProject } from "../hooks/projects";
import useProjectStore from "../store/projects";
import EditProjectForm from "./EditProjectForm";

const EditProjectDialog = () => {
  const {
    modals,
    closeModal,
    setModalOpen,
    currentProject: project,
  } = useProjectStore();

  const { toast } = useToast();
  const { updateProject } = useUpdateProject();
  const { refreshProjects } = useGetProjects();

  const handleEditProject = async (data) => {
    try {
      await updateProject(data);
      toast({
        title: "Success!",
        description: "Project updated successfully.",
        variant: "success",
      });
      handleClose();
    } catch (err) {
      toast({
        title: "Error!",
        description:
          "There was an error updating the project. Please try again.",
        variant: "destructive",
      });
    }
  };

  const handleClose = () => {
    refreshProjects();
    closeModal("edit");
  };

  return (
    <Dialog
      open={modals.edit}
      onOpenChange={(value) => setModalOpen("edit", value)}
    >
      <DialogContent className="sm:max-w-[425px]" open={open}>
        <DialogHeader>
          <DialogTitle className="tracking-widest font-medium">
            Edit Project{" "}
            <span className="font-semibold">{project?.name || ""}</span>
          </DialogTitle>
        </DialogHeader>

        <div className="mt-6">
          <EditProjectForm
            project={project}
            onCancel={handleClose}
            onSubmit={handleEditProject}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

EditProjectDialog.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    description: PropTypes.string,
  }),
};

export default EditProjectDialog;
